module.exports = __webpack_public_path__ + "img/prizePopupTitle.f242be8c.png";